import { __rest } from "tslib";
import * as React from 'react';
const FlagReview = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M6 5a1 1 0 011-1h11.54a.5.5 0 01.41.787L16.2 8.713a.5.5 0 000 .574l.489.697-1.028.275-.28-.399a1.5 1.5 0 010-1.72L17.58 5H7v8h4v1H7v6H6V5z" }),
        React.createElement("path", { fillRule: "evenodd", d: "M15.5 18c.659 0 1.274-.182 1.8-.498l2.008 2.525.784-.623-2.015-2.536A3.5 3.5 0 1015.5 18zm0-1a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" })));
};
FlagReview.displayName = 'FlagReview';
export default FlagReview;
//# sourceMappingURL=FlagReview.js.map